import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    TextField
} from 'mui-rff';
import { numberFormat, amountFormatInput,getVehicleInputValue, filterOut, filterWithOutFormattingVehicle,filterWithOutFormatting, getVehicleNumberDisplayValuesDWeb } from "../../../utils/utils";
function useRunAfterUpdate() {
    const afterPaintRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (afterPaintRef.current) {
            afterPaintRef.current();
            afterPaintRef.current = null;
        }
    });
    const runAfterUpdate = fn => (afterPaintRef.current = fn);
    return runAfterUpdate;
}
const TextInputState = (props) => {
    const { onChange, fromVehicle } = props;
    const runAfterUpdate = useRunAfterUpdate();
    const [deleteInput,setDeleteInput] = React.useState(false);
    const onInputChange = (evt) => {
        let deleteHappened = false;
        
        let input = evt.target;
        /*if(!deleteInput){
            input.value = getVehicleInputValue(input.value)
        }*/
        const text = input.value;
        const cursor = input.selectionStart;
        const [newValue, newCursor] = filterWithOutFormattingVehicle(text, cursor,deleteInput);
        if (typeof window != 'undefined') {
            window.requestAnimationFrame(() => {
                input.selectionStart = newCursor
                input.selectionEnd = newCursor
            })
        }
        evt.target.value = newValue;
        if (typeof onChange === 'function') {
            onChange(evt);
        }
        /*runAfterUpdate(() => {
            input.selectionStart = newCursor;
            input.selectionEnd = newCursor;
        });*/
    }
    return <TextField {...props} onChange={onInputChange} 
    onKeyDown={(evt)=>{
        if (evt.keyCode === 8 || evt.keyCode === 46) {
            setDeleteInput(true)
        }else{
            setDeleteInput(false)
        }
    }}  />
};
export default TextInputState;